import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';
import { baseApi } from '@shared/api/baseApi';
import { userApi } from '@entities/user';

const middlewares = [baseApi.middleware, userApi.middleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares),
});

export default store;
